import {
  BooleanInput,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useTranslate,
} from 'react-admin'

const typeChoices = [
  { id: 'marketing', name: 'marketing' },
  { id: 'setup', name: 'setup' },
]

const internalNameChoices = [
  { id: 'payments', name: 'payments' },
  { id: 'invoicing', name: 'invoicing' },
  { id: 'milestones', name: 'milestones' },
  { id: 'communications', name: 'communications' },
  { id: 'documents', name: 'documents' },
  { id: 'direct_payment', name: 'direct_payment' },
  { id: 'accounting', name: 'accounting' },
  { id: 'supplier_stripe_settings', name: 'supplier_stripe_settings' },
  { id: 'other', name: 'other (no automatic status tracking)' },
]

const stepTypeChoices = [
  { id: 'payment', name: 'payment' },
  { id: 'configuration', name: 'configuration' },
  { id: 'automation', name: 'automation' },
]

export const CheckpointForm = (props) => {
  const translate = useTranslate()
  return (
    <SimpleForm {...props}>
      <SelectInput source="internal_name" choices={internalNameChoices} fullWidth validate={[required()]} />
      <TextInput source="title" fullWidth validate={[required()]} />
      <TextInput source="description" fullWidth multiline />
      <TextInput source="primary_time" fullWidth helperText="e.g. 3 mins" />
      <TextInput source="secondary_time" fullWidth helperText="e.g. Review 1-2 business days" />
      <NumberInput source="priority" />
      <TextInput source="redirect_path" fullWidth />
      <ReferenceInput source="country" reference="countries" label={translate('Country')}>
        <SelectInput source="name" optionText="name" optionValue="id" />
      </ReferenceInput>
      <SelectInput source="type" choices={typeChoices} />
      <BooleanInput source="is_required" label="Required step" />
      <BooleanInput source="exclude_supplier_orgs" label="Exclude supplier orgs" />
      <BooleanInput source="exclude_non_supplier_orgs" label="Exclude non-supplier orgs" />
      <SelectInput source="step_type" choices={stepTypeChoices} emptyValue={null} />
      <TextInput source="icon" fullWidth />
      <TextInput
        source="details"
        fullWidth
        multiline
        minRows={4}
        helperText='Optional JSON, e.g. { "title": "", "description": "", "line_items": [] }'
        format={(v) => (typeof v === 'object' && v !== null ? JSON.stringify(v, null, 2) : v ?? '')}
        parse={(v) => {
          if (v == null || v === '') return null
          try {
            return JSON.parse(v)
          } catch {
            return v
          }
        }}
      />
    </SimpleForm>
  )
}
